/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 *
 */
import styled from 'styled-components';
import StyledProps from '../../../../common/theme/AppThemeInterface';

const ChartStyledWrapper = styled.div`
  background-color: ${({ theme }: StyledProps) => theme.primaryBackgroundColor};
  border-bottom: 1px solid ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};
  border-left: 1px solid ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};
  border-radius: 8px;
  width: 100%;
  position: relative;
  color: ${({ theme }: StyledProps) => theme.primaryTextColor};
  page-break-inside: avoid;

  div {
    overflow: visible;
    text-transform: none;
  }
  @media print {
    border-left: none;
    color: black;
    background-color: white;
    border-color: white;
    position: relative !important;
  }
`;

export default ChartStyledWrapper;
